const sidebar = {
  home: 'Home',
  customers: 'Customers',
  agents: 'Agenti',
  carbody: 'Carrozzeria',
  carbody_upload: 'Carica Prezzi',
  car_body_export_suppliers: 'Fornitori esportazione',
  car_body_cars_data: 'Marche e modelli',
  carbody_create_new_product: 'Crea prodotti',
  carbody_updatable_products: 'Aggiorna prodotti',
  car_body_tmp_products_index: 'Lista nuovi prodotti',
  car_body_pending_products_index: 'Prodotti da inviare',
  carbody_catalogue_sync: 'Sincronizza catalogo',
  carbody_catalogue_order: 'Ordina catalogo esportazione',
  classes_merch: 'Classi',
  classes_merch_cluster: 'Gestione Cluster',
  cat_ia: 'Test Cat-iA',
  cross_analyzer: 'Cross Analyzer',
  order_bot: 'Order Bot',
  documentation: 'Manuali',
  reward_bot: 'Reward Bot',
  q_bot: 'Q-Bot',
  q_bot_revenue: 'Agenti e Aree',
  bid_bot: 'Bid Bot',
  bid_bot_manage: 'Elenco richieste',
  bid_bot_send: 'Invia richiesta',
  x_bot: 'X-Bot',
  x_bot_import: 'Importa file',
  x_bot_cross: 'Genera file',
  manage: 'Gestione',
  pfa_rules: 'Premi annuali',
  promo: 'Promozioni',
  settings: 'Impostazioni',
  suppliers: 'Fornitori',
  users: 'Utenti',
  roles: 'Ruoli/Permessi',
  tags: 'Tags',
  telescope: 'Telescope Monitor',
  products_sizes: 'Dimensione Prodotti',
  stock_offers: 'Stock offers',
  traders: 'Traders',
  teccom: 'TecCom',
  teccom_orders: 'Invio Ordini',
  teccom_dispatch_advices_index: 'Bolle di consegna (DDT)',
  teccom_order_confirmations_index: "Conferme d'ordine",
  order_bot_manage_white_lists: 'Gestione forzature',
  manage_warehouse_distributions: 'Gestione perimetro teorico',
  five_thresholds_coefficients: 'Coefficienti 5 soglie',
  five_thresholds_constraints: 'Vincoli 5 soglie',
  economic_order_quantity: 'Parametri EOQ',
  warehouses_refilling_levels: 'Gestione livelli refilling',
  warehouses_hierarchies_classes_merchs: 'Gerarchie classi merceologiche',
  coefficients_thresholds_branch: 'Riduzione Scorte di Sicurezza',
  phantom_orders: 'Ordini phantom',
  stock_bot: 'Stock Bot',
  stock_bot_panoramica: 'Panoramica',
  stock_bot_dettagli: 'Dettagli',
  invoice_xml: 'Fatture XML',
  price_compare: 'Confronto Prezzi',
  price_compare_logs: 'Storico log',
  price_compare_simulate: 'Simulazione',
  q_ricambi: 'Q Ricambi',
  all_cross: 'All Cross',
}

export default sidebar